/**
 * Appstle Subscription widget: inject helper text under the delivery dropdown.
 * Uses MutationObserver + retries so it works regardless of when Appstle loads.
 */
(function () {
  if (document.querySelector('.template-product') === null) return;

  var PAUSE_ICON = 'https://cdn.shopify.com/s/files/1/1002/4389/8708/files/svg-image-24.svg?v=1773308323';
  var GIFT_ICON = 'https://cdn.shopify.com/s/files/1/1002/4389/8708/files/svg-image-25.svg?v=1773308321';

  // ----- Locale-aware Loyalty strings (Appstle's "Subscriber Rewards" sub-text) -----
  // Appstle's widget hardcodes the reward type label, the "Get X% off on N order and onwards."
  // description, and the "Orders N+" tier badge in English. These are not exposed in their admin
  // (only the section heading is — translated via Appstle "Subscriber Rewards Section Title").
  // We post-process the DOM to translate them per locale.
  function getLocale() {
    return (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  }

  var LOYALTY_STRINGS = {
    da: {
      'Percentage Discount': 'Procentrabat',
      'Fixed Amount Discount': 'Fast beløb',
      'Cycle Discount': 'Cyklusrabat',
      'Free Shipping': 'Gratis fragt',
      'Free Product': 'Gratis produkt',
      get: 'Få',
      onWord: 'fra',
      percentOff: function (pct) { return pct + '% rabat'; },
      orderAndOnwards: function (n) { return n + '. ordre og frem'; },
      ordersTier: function (n) { return 'Ordrer ' + n + '+'; }
    },
    sv: {
      'Percentage Discount': 'Procentrabatt',
      'Fixed Amount Discount': 'Fast belopp',
      'Cycle Discount': 'Cykelrabatt',
      'Free Shipping': 'Fri frakt',
      'Free Product': 'Gratis produkt',
      get: 'Få',
      onWord: 'från',
      percentOff: function (pct) { return pct + '% rabatt'; },
      orderAndOnwards: function (n) { return n + ':e ordern och framåt'; },
      ordersTier: function (n) { return 'Beställningar ' + n + '+'; }
    },
    de: {
      'Percentage Discount': 'Prozentrabatt',
      'Fixed Amount Discount': 'Fester Rabattbetrag',
      'Cycle Discount': 'Zyklusrabatt',
      'Free Shipping': 'Kostenloser Versand',
      'Free Product': 'Gratisprodukt',
      get: 'Erhalten Sie',
      onWord: 'ab',
      percentOff: function (pct) { return pct + '% Rabatt'; },
      orderAndOnwards: function (n) { return 'der ' + n + '. Bestellung'; },
      ordersTier: function (n) { return 'Bestellungen ' + n + '+'; }
    },
    nl: {
      'Percentage Discount': 'Procentkorting',
      'Fixed Amount Discount': 'Vast bedrag korting',
      'Cycle Discount': 'Cycluskorting',
      'Free Shipping': 'Gratis verzending',
      'Free Product': 'Gratis product',
      get: 'Krijg',
      onWord: 'vanaf',
      percentOff: function (pct) { return pct + '% korting'; },
      orderAndOnwards: function (n) { return n + 'e bestelling en daarna'; },
      ordersTier: function (n) { return 'Bestellingen ' + n + '+'; }
    }
  };

  function translateLoyaltyStrings() {
    var locale = getLocale();
    var dict = LOYALTY_STRINGS[locale];
    if (!dict) return;

    // 1. Reward type title: ".appstle-reward-title"
    var titles = document.querySelectorAll('.appstle-reward-title');
    titles.forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (dict[t] && el.dataset.vvI18n !== '1') {
        el.textContent = dict[t];
        el.dataset.vvI18n = '1';
      }
    });

    // 2. Billing cycle description: ".appstle-loyalty-billing-cycle" has text like "1 order and onwards"
    var cycles = document.querySelectorAll('.appstle-loyalty-billing-cycle');
    cycles.forEach(function (el) {
      if (el.dataset.vvI18n === '1') return;
      var raw = (el.textContent || '').trim();
      // Match "N order and onwards" or "N orders and onwards"
      var m = raw.match(/^(\d+)\s+orders?\s+and\s+onwards?\.?$/i);
      if (m) {
        el.textContent = dict.orderAndOnwards(m[1]);
        el.dataset.vvI18n = '1';
      }
    });

    // 3. Tier badge: ".appstle-loyalty-save-badge" has text like "Orders 1+"
    var badges = document.querySelectorAll('.appstle-loyalty-save-badge');
    badges.forEach(function (el) {
      if (el.dataset.vvI18n === '1') return;
      var raw = (el.textContent || '').trim();
      var m = raw.match(/^Orders?\s+(\d+)\+?$/i);
      if (m) {
        el.textContent = dict.ordersTier(m[1]);
        el.dataset.vvI18n = '1';
      }
    });

    // 4. Discount value: ".appstle-precentage-loyalty" has "15% off" — translate "off"
    var discounts = document.querySelectorAll('.appstle-precentage-loyalty');
    discounts.forEach(function (el) {
      if (el.dataset.vvI18n === '1') return;
      var raw = (el.textContent || '').trim();
      var m = raw.match(/^(\d+(?:[.,]\d+)?)\s*%\s*off$/i);
      if (m) {
        el.textContent = dict.percentOff(m[1]);
        el.dataset.vvI18n = '1';
      }
    });

    // 5. Description text nodes: ".appstle-reward-description" has "Get [...] on [...]."
    var descs = document.querySelectorAll('.appstle-reward-description');
    descs.forEach(function (el) {
      if (el.dataset.vvI18n === '1') return;
      // Walk direct child text nodes (the "Get" and "on" wrappers)
      for (var i = 0; i < el.childNodes.length; i++) {
        var node = el.childNodes[i];
        if (node.nodeType === 3) {
          var raw = (node.nodeValue || '').replace(/ /g, ' ').trim();
          if (raw === 'Get') {
            node.nodeValue = node.nodeValue.replace(/Get/, dict.get);
          } else if (raw === 'on') {
            node.nodeValue = node.nodeValue.replace(/on/, dict.onWord);
          }
        }
      }
      el.dataset.vvI18n = '1';
    });
  }

  function hasAppstleHelper() {
    var buyBox = document.querySelector('.product__buy-buttons');
    if (!buyBox) return false;
    var text = buyBox.textContent || '';
    // Only skip if Appstle itself rendered similar text (not our own injection)
    var existing = document.querySelector('.vv-subscription-helper');
    if (existing) return false;
    return (text.indexOf('Pause or cancel') !== -1 || text.indexOf('Free shipping') !== -1);
  }

  function isBlockLevelContainer(el) {
    if (!el) return false;
    var tag = el.tagName;
    // Skip inline elements like SPAN that aren't real containers
    if (tag === 'SPAN' || tag === 'IMG' || tag === 'A' || tag === 'BUTTON' || tag === 'INPUT' || tag === 'LABEL') return false;
    // Must be inside the product form area
    return !!el.closest('.product-form, .product, .main-product');
  }

  function findAppstleContainer() {
    // Look for block-level Appstle widget containers inside the product form
    var selectors = [
      'appstle-subscription-widget',
      '[id^="appstle_subscription_widget"]',
      '[id^="appstle_subscription_contents"]',
      '[id^="appstle_subscription"]',
      '.appstle_subscription_wrapper',
      '.appstle-widget-1',
      '[class*="appstle_subscription_wrapper"]',
      '[class*="appstle-subscription"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && isBlockLevelContainer(el)) return el;
    }

    // Fallback: any [id*="appstle"] or [class*="appstle"] that's a block element inside product-form
    var candidates = document.querySelectorAll('.product-form [id*="appstle"], .product-form [class*="appstle"], .product-form [class*="Appstle"]');
    for (var j = 0; j < candidates.length; j++) {
      if (isBlockLevelContainer(candidates[j])) return candidates[j];
    }

    // Last resort: subscription/selling-plan/purchase-option blocks
    var subs = document.querySelectorAll(
      '.product-form [class*="subscription"], .product-form [class*="selling-plan"], .product-form [class*="purchase-option"]'
    );
    for (var k = 0; k < subs.length; k++) {
      var txt = subs[k].textContent || '';
      if ((txt.indexOf('Subscribe') !== -1 || txt.indexOf('Delivery') !== -1 || txt.indexOf('Every') !== -1) && isBlockLevelContainer(subs[k])) {
        return subs[k];
      }
    }
    return null;
  }

  function injectSubscriptionHelper() {
    if (document.querySelector('.vv-subscription-helper')) return true;
    if (hasAppstleHelper()) return true;

    var container = findAppstleContainer();
    if (!container) return false;

    var dropdown =
      container.querySelector('select') ||
      container.querySelector('[class*="frequency"]') ||
      container.querySelector('[class*="delivery"]');

    var insertAfter = dropdown ? dropdown.closest('div') || dropdown : container.querySelector('div') || container;

    var wrapper = document.createElement('div');
    wrapper.className = 'vv-subscription-helper';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.style.cssText =
      'display:flex;flex-wrap:wrap;gap:1rem 2rem;margin-top:0.75rem;font-size:12px;color:var(--color-foreground-secondary,rgba(0,0,0,0.75));align-items:center;';

    function makeLine(iconUrl, text) {
      var line = document.createElement('span');
      line.style.display = 'inline-flex';
      line.style.alignItems = 'center';
      line.style.gap = '6px';
      var img = document.createElement('img');
      img.src = iconUrl;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.width = '14px';
      img.style.height = '14px';
      img.style.flexShrink = '0';
      line.appendChild(img);
      line.appendChild(document.createTextNode(text));
      return line;
    }

    // Locale-aware "Pause or cancel" copy. Falls back to EN.
    var locale = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var pauseCopy = {
      da: 'Pause eller opsig når som helst',
      sv: 'Pausa eller avbryt när du vill',
      nl: 'Pauzeer of zeg op wanneer je wilt',
      de: 'Pausieren oder kündigen jederzeit'
    }[locale] || 'Pause or cancel at any time';
    wrapper.appendChild(makeLine(PAUSE_ICON, pauseCopy));
    // "Free shipping on every order" removed per merchant request — the free
    // shipping benefit doesn't apply unconditionally so we don't show it here.

    if (insertAfter.nextSibling) {
      insertAfter.parentNode.insertBefore(wrapper, insertAfter.nextSibling);
    } else {
      insertAfter.appendChild(wrapper);
    }
    return true;
  }

  // Try once at each of these checkpoints, and stop when successful
  var attemptDelays = [0, 300, 800, 1500, 3000, 5000, 8000, 12000];
  var observer = null;

  function tryInject() {
    // Always attempt loyalty translation — it can succeed even if helper doesn't (and vice versa)
    translateLoyaltyStrings();
    if (injectSubscriptionHelper()) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      return true;
    }
    return false;
  }

  function scheduleAttempts() {
    attemptDelays.forEach(function (ms) {
      setTimeout(tryInject, ms);
    });
  }

  // Set up MutationObserver to catch Appstle rendering at any time
  function setupObserver() {
    var productForm = document.querySelector('.product-form') || document.body;
    if (!productForm) return;
    observer = new MutationObserver(function () {
      tryInject();
    });
    observer.observe(productForm, { childList: true, subtree: true });

    // Safety: stop observing after 20s to avoid indefinite work
    setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }, 20000);
  }

  function boot() {
    scheduleAttempts();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run if section is re-rendered (e.g., variant change, theme editor)
  document.addEventListener('shopify:section:load', function () {
    // Remove old helper so it can be re-injected into the fresh DOM
    var old = document.querySelector('.vv-subscription-helper');
    if (old) old.remove();
    setTimeout(boot, 200);
  });

  // Re-run on variant change (Appstle re-renders the widget)
  document.addEventListener('variant:change', function () {
    setTimeout(tryInject, 500);
    setTimeout(tryInject, 1500);
    setTimeout(translateLoyaltyStrings, 2500);
  });

  // Re-run on selling plan change (loyalty section can re-render)
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name || '').toLowerCase().indexOf('selling') !== -1) {
      setTimeout(translateLoyaltyStrings, 300);
      setTimeout(translateLoyaltyStrings, 1000);
    }
  });
})();
